<template>
    <div class="book-area">
      <el-row>
        <el-col :span="4" v-for="book in books" :key="book.id" style="padding: 10px">
          <div @click="showDialog(book)">
            <el-card class="book" :body-style="{ padding: '10px' }" shadow="hover">
              <div class="bookname" slot="header" style="height: 30px">
                {{book.name}}
              </div>
              <el-image class="bookimage" :src="`https://awesome-platform.oss-cn-shanghai.aliyuncs.com${book['cover_img_url']}`"></el-image>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-dialog
      :title="currentBook!=null?currentBook.name:''" style="text-align: left;line-height: 30px"
      :visible.sync="currentBookDialog"
      center>
        <div>
          测试范围: 
          <el-radio-group style="margin: 0 0 0 30px" v-model="trainArea">
            <el-radio label="unit">单元</el-radio>
            <el-radio label="book">课本</el-radio>
          </el-radio-group>
        </div>
        <div>
          题目类型: 
          <el-radio-group style="margin: 0 0 0 30px" v-model="trainType">
            <el-radio label="read">认读</el-radio>
            <el-radio label="listen">辩音</el-radio>
            <el-radio label="write">拼写</el-radio>
            <el-radio label="all">综合</el-radio>
          </el-radio-group>
        </div>
        <div>
          题目数量: 
          <el-radio-group style="margin: 0 0 0 30px" v-model="questionCount">
            <el-radio label="less">较少</el-radio>
            <el-radio label="many">较多</el-radio>
            <el-radio :disabled="trainArea == 'book'" label="all">全部</el-radio>
          </el-radio-group>
        </div>
        <div v-if="trainArea != 'book'">
          测试章节:
        </div>
        <el-row  v-if="trainArea != 'book'">
          <el-checkbox-group 
            v-model="selectWords"
            :max="6">
            <el-col :span="6" v-for="unit in currentBookUnits" :key="unit.id">
              <el-checkbox :label="unit.words">{{unit.name}}</el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="currentBookDialog = false">取 消</el-button>
          <el-button type="primary" @click="startTrain">开始测试</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui';

export default {
  data() {
    return {
      baseApi: '/train',
      bookApi: '/book',
      books: [],
      currentBook: null,
      currentBookDialog: false,
      currentBookUnits: [],
      trainArea: 'unit',
      trainType: 'read',
      questionCount: 'less',
      selectWords: [],
    }
  },
  watch: {
    trainArea: function(n){
      if (n == 'book' && this.questionCount == 'all') {
        this.questionCount = 'less'
      }
      this.selectWords = []
    }
  },
  computed: {
    ...mapGetters({
      info: 'getInfo',
    })
  },
  created() {
    this.searchMyBook()
  },
  methods: {
    searchMyBook() {
      this.$fly.post(`${this.bookApi}/unlocked/search-books`,{'studentAccountId.eLong': this.info.id}).then((res)=>{
        this.books = res
      })
    },
    showDialog(book) {
      this.currentBook = book;
      this.selectWords = [];
      this.$fly.post(`${this.baseApi}/units/${this.currentBook.id}`).then((res)=>{
        this.currentBookUnits = res
        this.currentBookDialog = true;
      })
    },
    startTrain() {
      if (this.trainArea == 'book') {
        for (let i = 0; i < this.currentBookUnits.length; i++) {
          let u = this.currentBookUnits[i];
          this.selectWords.push(u.words)
        }
      }
      if (this.selectWords == null || this.selectWords.length == 0) {
        Message.error('请选择至少一个单元!')
      } else {
        this.$router.push({
        name: '练习',
        params: {
          'name': `${this.currentBook.name} 单元测试`,
          'type': this.trainType == 'read'?1:this.trainType == 'listen'?2:this.trainType == 'write'?3:4,
          'questionCount': this.questionCount == 'less'?20:this.questionCount == 'many'?40:3000,
          'words': this.selectWords,
        }
      })
      }
    }
  }
}
</script>
<style scoped>
.book{
  border-radius: 10px
}
.bookimage{
  width: 90%;
  border-radius: 10px
}
.col{
  padding: 15px
}
.bookname{
}
@media screen and (max-width: 1400px) { 
  .bookname{
    font-size: 10px;
  }
  .book{
    border-radius: 5px
  }
  .bookimage{
    width: 90%;
    border-radius: 5px
  }
  .col{
    padding: 5px
  }
}
.book-area{
  padding: 20px 80px;
  overflow-y: hidden;
}
</style>